import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  ADD_COMMENT_ERROR,
  ADD_COMMENT_REQUEST,
  ADD_COMMENT_SUCCESS,
  CHANGE_COMMENT_REQUEST,
  CHANGE_COMMENT_SUCCESS,
  CLOSE_COMMENTS_MODAL,
  DELETE_COMMENT_SUCCESS,
  GET_ALL_COMMENTS_ERROR,
  GET_ALL_COMMENTS_REQUEST,
  GET_ALL_COMMENTS_SUCCESS,
  OPEN_COMMENTS_MODAL,
  RESET_COMMENTS_FORM_STATUS,
} from 'modules/commentsModal/actions';

const initialState = {
  comments: [],
  isModalOpen: false,
  monthIndexForSort: null,
  dayIndexForSort: null,
  dateModeForSort: 'month',
  chartType: null,
  error: '',
  status: STATUS_NOT_REQUESTED,
  submitFormStatus: STATUS_NOT_REQUESTED,
};

export const commentsModal = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_COMMENTS_MODAL: {
      const { month, day, chartType, dateMode } = action.payload;
      return {
        ...state,
        dayIndexForSort: Number(day),
        monthIndexForSort: Number(month),
        chartType,
        dateModeForSort: dateMode,
        isModalOpen: true,
      };
    }

    case CLOSE_COMMENTS_MODAL:
      return {
        ...state,
        dayIndexForSort: null,
        monthIndexForSort: null,
        chartType: null,
        dateModeForSort: null,
        isModalOpen: false,
      };

    case GET_ALL_COMMENTS_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
      };

    case GET_ALL_COMMENTS_SUCCESS:
      return {
        ...state,
        comments: action.payload.comments,
        status: STATUS_SUCCESS,
      };

    case GET_ALL_COMMENTS_ERROR:
      return {
        ...state,
        error: action.payload.error,
        status: STATUS_ERROR,
        comments: [],
      };

    case ADD_COMMENT_REQUEST:
    case CHANGE_COMMENT_REQUEST:
      return {
        ...state,
        submitFormStatus: STATUS_LOADING,
      };

    case ADD_COMMENT_SUCCESS: {
      const { text, type, date, id } = action.payload;
      return {
        ...state,
        comments: [
          ...state.comments,
          {
            id,
            text,
            lastUpdated: new Date().toISOString(),
            date,
            type,
          },
        ],
        submitFormStatus: STATUS_SUCCESS,
      };
    }

    case ADD_COMMENT_ERROR:
      return {
        ...state,
        submitFormStatus: STATUS_ERROR,
      };

    case RESET_COMMENTS_FORM_STATUS:
      return {
        ...state,
        submitFormStatus: STATUS_NOT_REQUESTED,
      };

    case CHANGE_COMMENT_SUCCESS: {
      const { text, commentId } = action.payload;
      return {
        ...state,
        comments: state.comments.map((comment) =>
          comment.id === commentId ? { ...comment, text } : comment
        ),
        submitFormStatus: STATUS_SUCCESS,
      };
    }

    case DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        comments: state.comments.filter(
          (comment) => comment.id !== action.payload.commentId
        ),
      };

    default:
      return state;
  }
};
